import {Injectable} from '@angular/core';
import * as screenfull from 'screenfull';

const CONSTRAINS = {
  video: {
    width: {
      ideal: 640
    },
    height: {
      ideal: 480
    },
    frameRate: {
      ideal: 10
    }
  },
  audio: false
};

@Injectable({
  providedIn: 'root'
})
export class CameraService {
  public videoElement: any;
  public localStream: any;
  public errMsg: any;
  public cameraIsEnable: boolean;

  constructor() {
    this.cameraIsEnable = false;
  }

  public initVideoElement(videoElement: any) {
    this.videoElement = videoElement;
  }

  public startCamera(callback: any = null) {
    console.log('start Video');
    this.errMsg = undefined;
    if (this.localStream) {
      this.stopCamera();
    }
    this.cameraIsEnable = false;
    navigator.mediaDevices.getUserMedia(CONSTRAINS)
      .then(stream => {
        this.localStream = stream;
        this.videoElement.srcObject = stream;
        this.videoElement.muted = true;
        this.cameraIsEnable = true;
        if (callback) {
          callback();
        }
      })
      .catch(error => {
        if (error) {
          console.log(error.message);
        }
        this.errMsg = 'Camera not found';
        console.log('catch mediaDevices.getUserMedia(CONSTRAINS)');
      });

    /*this.videoElement.addEventListener('loadedmetadata', () => {
      console.log('Local video videoWidth: ' + this.videoWidth + 'px,  videoHeight: ' + this.videoHeight + 'px');
    });*/
  }

  public stopCamera() {
    if (this.localStream) {
      const tracks = this.localStream.getTracks();
      tracks.forEach((track: MediaStreamTrack) => {
        track.stop();
      });
      this.localStream = null;
    }
  }

  fullScreen() {
    if (screenfull.toggle != null) {
      screenfull.toggle();
    }
  }
}
